import { z } from 'zod';

import {
  BaseFlowBlockSchema,
  BlockType,
  ConsumerOfPatientSchema,
  DurationSchemaWithMax,
  DurationUnits,
  ProducedType,
  returnTypeSchema,
} from '../base/baseSchema.js';

export const HieQueryDocumentsBlockConfigSchema = z.object({
  patient: ConsumerOfPatientSchema({ isRequired: false }),
  facilityId: z.string(),
  timeout: DurationSchemaWithMax('timeout', {
    value: 30,
    units: DurationUnits.Minutes,
  }),
});

export type HieQueryDocumentsBlockConfig = z.infer<typeof HieQueryDocumentsBlockConfigSchema>;

export const HieQueryDocumentsBlockSchema = BaseFlowBlockSchema.extend({
  type: z.literal(BlockType.HieQueryDocuments),
  config: HieQueryDocumentsBlockConfigSchema,
  returnType: returnTypeSchema(ProducedType.Any),
});
export type HieQueryDocumentsBlock = z.infer<typeof HieQueryDocumentsBlockSchema>;
